/**
 * Keeps the Tiger-only purchase-ticket fields in step with Horizon's native
 * variant selection response. Horizon remains responsible for resolving
 * variants, prices, availability, media, Shop Pay and cart submission.
 */
const TIGER_TICKET_SELECTORS = [
  '[data-tiger-ticket-meta]',
  '[data-tiger-ticket-summary]',
  '[data-tiger-ticket-saving]',
];

document.addEventListener('shopify:product:select', (event) => {
  if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

  const currentSection = event.target.closest('.shopify-section');
  const currentTicket = currentSection?.querySelector(
    ".product-details[data-tiger-purchase-style='compact_field_ticket']"
  );

  if (!currentSection || !currentTicket || !event.promise) return;

  event.promise
    .then(({ detail }) => {
      const responseDocument = detail?.html;
      if (!responseDocument) return;

      const sectionId = currentTicket.querySelector('[data-section-id]')?.dataset.sectionId;
      const responseSection = sectionId
        ? responseDocument.querySelector(`#shopify-section-${CSS.escape(sectionId)}`) ?? responseDocument
        : responseDocument;

      for (const selector of TIGER_TICKET_SELECTORS) {
        const currentElement = currentTicket.querySelector(selector);
        const nextElement = responseSection.querySelector(selector);
        if (!currentElement || !nextElement) continue;

        currentElement.replaceWith(nextElement.cloneNode(true));
      }
    })
    .catch((error) => {
      if (error?.name !== 'AbortError') {
        console.warn('[tiger-product-ticket] Variant refresh failed:', error);
      }
    });
});
